// Module
var code = "<div> <a href class=action-toggle ng-click=vm.toggleTab() translate=\"{{ vm.currentTab }}\"> </a> </div> ";
// Exports
var _module_exports = code;;
var path = 'app/common/ui/actionTabs/templates/actionTabs.toggle.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;